/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationPublicDataBuilderPublicDataBaseFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBase';
/**
 * Check if a given object implements the FxIdWebFeaturesGamesListWithConfigsResponse interface.
 */
export function instanceOfFxIdWebFeaturesGamesListWithConfigsResponse(value) {
    if (!('AvailableGames' in value) || value['AvailableGames'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesListWithConfigsResponseFromJSON(json) {
    return FxIdWebFeaturesGamesListWithConfigsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesListWithConfigsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AvailableGames': (json['AvailableGames'].map(FxIdApplicationPublicDataBuilderPublicDataBaseFromJSON)),
    };
}
export function FxIdWebFeaturesGamesListWithConfigsResponseToJSON(json) {
    return FxIdWebFeaturesGamesListWithConfigsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesListWithConfigsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AvailableGames': (value['AvailableGames'].map(FxIdApplicationPublicDataBuilderPublicDataBaseToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesListWithConfigsResponse.js.map